import React, { useContext, useEffect, useRef, useState } from "react";
import NewProjectContext from "../../../contexts/NewProjectContext";
import Button from "../../common/Button/index.jsx";
import { ReactComponent as ArrowRightSvg } from "../../../assets/icons/arrow-right.svg";
import { ReactComponent as ArrowLeftSvg } from "../../../assets/icons/arrow-left.svg";

import CircleArrowRight from "../../../assets/workExchange/arrow-right-circle.svg";
import CircleArrowRightDisable from "../../../assets/workExchange/arrow-right-circle-disabled.svg";
import CircleArrowLeft from "../../../assets/workExchange/arrow-left-circle.svg";
import CircleArrowLeftDisable from "../../../assets/workExchange/arrow-left-circle-disabled.svg";
import { ReactComponent as ProjectTypeSVG } from "../../../assets/workExchange/project-type.svg";
import AppContext from "../../../AppContext.jsx";
import {
  langComponent,
  PAGE_STATE,
  PROGRAM_MAPPING,
  RENDERER_MAPPING,
} from "../../../constants/index.jsx";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import useWorks from "../../../hooks/useWorks.js";
import ProgramSketchUpImage from "../../../assets/icons/programs/sketchUp.png";
import Program3dsMaxImage from "../../../assets/icons/programs/3dsMax.png";
import ProgramRevitImage from "../../../assets/icons/programs/autodeskRevit.png";
import ProgramCinema4DImage from "../../../assets/icons/programs/cinema4d.png";
import ProgramUnrealImage from "../../../assets/icons/programs/unreal.png";
import ProgramRhinoImage from "../../../assets/icons/programs/rhino.png";
import ProgramAutocadImage from "../../../assets/icons/programs/autocad.png";
import ProgramArchicadImage from "../../../assets/icons/programs/archicad.png";
import ProgramVRayImage from "../../../assets/icons/programs/vray.png";
import ProgramCoronaImage from "../../../assets/icons/programs/corona.png";
import ProgramLumionImage from "../../../assets/icons/programs/lumion.png";
import ProgramEnscapeImage from "../../../assets/icons/programs/enscape.jpg";
import ProgramD5RenderImage from "../../../assets/icons/programs/d5render.png";
import FileUpload from "./WorkFileUpload.jsx";
import { useScreenSize } from "../../index.js";
import { toast } from "react-toastify";
import Breadcrumb from "../../Breadcrumb/index.jsx";

const prefix = "new-project-work-exchange-summary";

const WorkExchangeSummary = () => {
  const {
    details: { workExchange, workType },
    goBackward,
    onSuccess,
    edit,
  } = useContext(NewProjectContext);
  const {
    user,
    getLang,
    designStyles: { workExchanges },
  } = useContext(AppContext);
  const Translation = getLang(langComponent.workExchange);
  const {
    createWork,
    uploadBanner,
    uploadImages,
    uploadWorkFiles,
    patchWork,
    deleteWorkImage,
  } = useWorks();
  const TranslationCommon = getLang(langComponent.common);
  const [pageState, setPageState] = useState(PAGE_STATE.LOADING);
  const [uploadingState, setUploadingState] = useState(PAGE_STATE.IDLE);

  const [currentSlide, setCurrentSlide] = useState(0);
  const swiperRef = useRef(null);

  const { screenSize } = useScreenSize();

  const [slider, setSlider] = useState(3);

  const PROGRAMS = {
    sketchUp: "sketchUp",
    "3dsMax": "3dsMax",
    revit: "revit",
    cinema4D: "cinema4D",
    unreal: "unreal",
    rhino: "rhino",
    autocad: "autocad",
    archicad: "archicad",
  };

  const RENDERERS = {
    vray: "vray",
    corona: "corona",
    lumion: "lumion",
    enscape: "enscape",
    d5render: "d5render",
  };

  const _getProgram = (program) => {
    if (program == PROGRAMS.sketchUp) {
      return <img src={ProgramSketchUpImage} />;
    } else if (program == PROGRAMS["3dsMax"]) {
      return <img src={Program3dsMaxImage} />;
    } else if (program == PROGRAMS.revit) {
      return <img src={ProgramRevitImage} />;
    } else if (program == PROGRAMS.cinema4D) {
      return <img src={ProgramCinema4DImage} />;
    } else if (program == PROGRAMS.unreal) {
      return <img src={ProgramUnrealImage} />;
    } else if (program == PROGRAMS.rhino) {
      return <img src={ProgramRhinoImage} />;
    } else if (program == PROGRAMS.autocad) {
      return <img src={ProgramAutocadImage} />;
    } else if (program == PROGRAMS.archicad) {
      return <img src={ProgramArchicadImage} />;
    }
  };

  const _getRenderer = (renderer) => {
    if (renderer == RENDERERS.vray) {
      return <img src={ProgramVRayImage} />;
    } else if (renderer == RENDERERS.corona) {
      return <img src={ProgramCoronaImage} />;
    } else if (renderer == RENDERERS.lumion) {
      return <img src={ProgramLumionImage} />;
    } else if (renderer == RENDERERS.enscape) {
      return <img src={ProgramEnscapeImage} />;
    } else if (renderer == RENDERERS.d5render) {
      return <img src={ProgramD5RenderImage} />;
    }
  };

  useEffect(() => {
    if (["xs", "sm"].includes(screenSize)) {
      setSlider(1);
    }
    if (["md"].includes(screenSize)) {
      setSlider(2);
    }
    if (["lg", "xl"].includes(screenSize)) {
      setSlider(3);
    }
  }, [screenSize]);

  const renderFooter = () => {
    if (!images.length) return;

    return (
      <div className={`${prefix}-content`}>
        <div className={`${prefix}-content-header`}>
          {images.length === 1 ? (
            ""
          ) : (
            <div className={`${prefix}-content-title`}>
              <a className={`${prefix}-content-title__name`}></a>
              <div className={`${prefix}-content-title__btn-group`}>
                <img
                  role="button"
                  src={isDisablePrev ? CircleArrowLeftDisable : CircleArrowLeft}
                  className={""}
                  width={50}
                  height={50}
                  onClick={() => {
                    swiperRef.current.swiper.slidePrev();
                  }}
                />
                <img
                  role="button"
                  src={
                    isDisableNext ? CircleArrowRightDisable : CircleArrowRight
                  }
                  className={""}
                  width={50}
                  height={50}
                  onClick={() => {
                    swiperRef.current.swiper.slideNext();
                  }}
                />
              </div>
            </div>
          )}

          <div className={`${prefix}-content-group`}>
            {
              <Swiper
                grabCursor={true}
                centeredSlides={false}
                slidesPerView={slider}
                spaceBetween={20}
                navigation={false}
                ref={swiperRef}
                modules={[Navigation]}
                onSlideChange={(swiperCore) => {
                  const { activeIndex } = swiperCore;
                  setCurrentSlide(activeIndex);
                }}
              >
                {[...images].map(({ _id, path }, index) => {
                  const url =
                    typeof path === "string" ? path : URL.createObjectURL(path);
                  return (
                    <SwiperSlide key={index}>
                      <div className={`${prefix}-content-group-silder`}>
                        <img
                          className={`${prefix}-content-group-silder__image`}
                          src={url}
                          alt={url}
                        />
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            }
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    setPageState(PAGE_STATE.IDLE);

    return () => {};
  }, []);

  if (pageState !== PAGE_STATE.IDLE) {
    return <h1>Loading...</h1>;
  }

  const handleSubmitInfo = async (draft = false) => {
    const {
      info: {
        _id,
        name,
        desc,
        discount,
        program,
        renderer,
        type,
        price,
        fileTypes,
        keywords,
        category,
        subCategory,
        materials,
      },
      cover: { cropped },
      images,
      files,
    } = workExchange;

    setUploadingState(PAGE_STATE.LOADING);

    const _body = {
      name,
      desc,
      program: program ? PROGRAM_MAPPING[program] : null,
      renderer: renderer ? RENDERER_MAPPING[renderer] : null,
      price,
      discount: discount ?? 0,
      type: 2,
      designType: {
        workExchange: workType,
        workExchangeCategory: category,
        workExchangeSubCategory: subCategory,
        workExchangeMaterials: materials ?? [],
      },
      panorama: {
        images: [],
      },
      workFileTypes: fileTypes,
      company: user?.company ? user.company : undefined,
      active: !draft,
      deleted: true,
      keywords,
    };

    if (!edit) {
      try {
        const _work = await createWork(_body);

        const result = await Promise.allSettled([
          uploadBanner(_work._id, cropped),
          uploadImages(
            _work._id,
            images.map((_) => _.path),
            images.map((_, index) => index)
          ),
          uploadWorkFiles(_work._id, files),
        ]);

        if (result.some((r) => r.status === "rejected")) {
          toast.error("Unable to save project. Please try again later");
          setUploadingState(PAGE_STATE.IDLE);
          return;
        }

        // * Remove deleted to show on platform
        await patchWork(_work._id, {
          deleted: false,
        });

        setUploadingState(PAGE_STATE.IDLE);
        onSuccess(_work._id);
      } catch (error) {
        debugger;
        toast.error("Unable to save project. Please try again later");
        setUploadingState(PAGE_STATE.IDLE);
        console.error(error);
      }
    } else {
      try {
        _body.designType.workExchange = type;

        await patchWork(edit, _body);

        const result = await Promise.allSettled([
          uploadBanner(edit, cropped),
          uploadImages(
            edit,
            images.map((_) => _.path),
            images.map((_, index) => index)
          ),
          uploadWorkFiles(edit, files),
        ]);

        if (result.some((r) => r.status === "rejected")) {
          debugger;
          toast.error("Unable to save project. Please try again later");
          setUploadingState(PAGE_STATE.IDLE);
          return;
        }

        // * Remove deleted to show on platform
        await patchWork(edit, {
          deleted: false,
        });

        setUploadingState(PAGE_STATE.IDLE);
        onSuccess(edit);
      } catch (error) {
        debugger;
        toast.error("Unable to save project. Please try again later");
        setUploadingState(PAGE_STATE.IDLE);
        console.error(error);
      }
    }
  };

  const {
    info: {
      name,
      price,
      discount,
      program,
      desc,
      renderer,
      categories: _categories,
      category,
      subCategory,
      materials,
      fileTypes,
      keywords,
      type,
    },
    cover: { cropped: cover, dataUrl },
    images,
    files,
  } = workExchange;

  const isDisablePrev = currentSlide === 0;
  const isDisableNext = currentSlide === images.length;

  const renderFile = () => {
    return (
      <div className={`${prefix}-upload-file`}>
        <div className={`${prefix}-upload-file-title`}>
          {Translation("Work Files")}
        </div>
        {files.map((file) => {
          return <FileUpload file={file} isDelete={false} />;
        })}
      </div>
    );
  };

  const _category = workExchanges
    .find((we) => we.value === type)
    .categories.find((cat) => cat._id === category);

  const _sub = _category.subs.find((sc) => sc._id === subCategory);

  let _materials = [];

  if (materials && materials.length > 0) {
    _materials = materials
      .map((m) => _sub.materials.find((material) => material._id === m).name)
      .join(", ");
  }

  return (
    <>
      <div className={`${prefix}-breadcrumb`}>
        <Breadcrumb
          config={[
            {
              path: "/",
              breadcrumb: _category.name,
              props: {
                noLink: true,
                // pathname: `/art-designs/work-exchanges/${workExchange}?category=${workExchangeCategory}`,
              },
            },
            {
              path: "/new-project",
              breadcrumb: _sub.name,
              props: {
                noLink: true,
                // pathname: `/art-designs/work-exchanges/${workExchange}?category=${workExchangeCategory}&sub=${workExchangeSubCategory}`,
              },
            },
          ]}
        />
      </div>
      <div className={`${prefix}-header`}>
        <div className={`${prefix}-header-container`}>
          <div className={`${prefix}-header-info`}>
            <div className={`${prefix}-header-info__title`}>{name}</div>
            <div className={`${prefix}-header-info__price`}>
              <span className={`${prefix}-header-info__price--discount`}>
                {discount > 0 ? price?.toLocaleString() : ""}
              </span>{" "}
              {price > 0
                ? discount > 0
                  ? (price - discount).toLocaleString()
                  : price?.toLocaleString()
                : "Free"}
            </div>
            <div className={`${prefix}-header-info__detail`}>
              <label className={`${prefix}-header-info__detail__label`}>
                Created using
              </label>
              <div
                className={`${prefix}-header-info__detail__value ${prefix}-header-info__apps`}
              >
                {_getProgram(program ?? 1)}
                {_getRenderer(renderer ?? 1)}
              </div>
            </div>
            <div className={`${prefix}-header-info__detail`}>
              <label className={`${prefix}-header-info__detail__label`}>
                File Types
              </label>
              <div className={`${prefix}-header-info__detail__value`}>
                {fileTypes.join(", ")}
              </div>
            </div>
            <div className={`${prefix}-header-info__detail`}>
              <label className={`${prefix}-header-info__detail__label`}>
                Materials
              </label>
              <div className={`${prefix}-header-info__detail__value`}>
                {_materials}
              </div>
            </div>
            <div className={`${prefix}-header-info__desc`}>
              <label>Description</label>
              <span>{desc}</span>
            </div>
            {keywords && keywords.length > 0 && (
              <div className={`${prefix}-header-info-keywords`}>
                {keywords.map((kw) => (
                  <div className={`${prefix}-header-info-keywords__tag`}>
                    {kw}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className={`${prefix}-header-cover`}>
          <img
            className={`${prefix}-header-cover__image`}
            // src={URL.createObjectURL(cover)}
            src={dataUrl}
            alt={"cover image"}
          />
        </div>
      </div>
      {renderFooter()}
      {renderFile()}
      <div
        className="new-project-work-exchange__footer"
        style={{ gridColumn: "1 / 3" }}
      >
        {uploadingState === PAGE_STATE.LOADING && (
          <>Uploading, please don't close this window</>
        )}
        {uploadingState !== PAGE_STATE.LOADING && (
          <>
            <Button
              label={TranslationCommon("Return")}
              variant={"secondary"}
              leadingIcon={<ArrowLeftSvg />}
              onClick={() => goBackward()}
            />
            <div className={`${prefix}-footer__right`}>
              <Button
                variant={"secondary"}
                label={TranslationCommon(
                  "Save draft"
                  // workExchange?.editMode ? "Draft project" : "Share Project"
                )}
                onClick={async () => {
                  await handleSubmitInfo(true);
                }}
              />
              <Button
                label={TranslationCommon(edit ? "Save" : "Share Project")}
                type="submit"
                trailingIcon={<ArrowRightSvg />}
                onClick={async () => {
                  await handleSubmitInfo(false);
                }}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

WorkExchangeSummary.propTypes = {};
WorkExchangeSummary.defaultProps = {};

export default WorkExchangeSummary;
